import { validatePeriodSearch } from '../report-period'
import type { ReportPeriodSearch } from '../report-period'

/** Kỳ mặc định của Báo cáo xuất kho: Hôm nay (cùng báo cáo bán hàng). */
export const STOCK_OUT_DEFAULT_PRESET = 'today' as const

/** Chỉ có bộ lọc thời gian; không có chế độ Biểu đồ (owner chốt 2026-10-02). */
export type StockOutReportSearch = ReportPeriodSearch

export function validateStockOutReportSearch(
    raw: Record<string, unknown>,
): StockOutReportSearch {
    return {
        ...validatePeriodSearch({
            ...raw,
            preset: raw.preset ?? STOCK_OUT_DEFAULT_PRESET,
        }),
        display: 'report',
    }
}
